import { createSlice } from '@reduxjs/toolkit';

// Models:
import type { IBreadCrumbs } from '../../../data/models/header/breadcrumb.model';

interface IMetadataReducer {
  breadcrumbs: IBreadCrumbs[];
  title: string;
  text: string;
  h1: string;
  short_description: string;
}

const initialState: IMetadataReducer = {
  breadcrumbs: [],
  title: '',
  text: '',
  h1: '',
  short_description: '',
};

const name = 'metadata';

const metadataSlice = createSlice({
  name,
  initialState,
  reducers: {},
});

export default metadataSlice.reducer;
